export default __webpack_public_path__ + "locales/zh-CN/EmptyTrashDialog.json?hash=07859a17ea7e4547527123af6d1deeb2";